import { render } from "./TF2Load.vue?vue&type=template&id=0898fa3a&scoped=true"
import script from "./TF2Load.vue?vue&type=script&lang=js"
export * from "./TF2Load.vue?vue&type=script&lang=js"

import "./TF2Load.vue?vue&type=style&index=0&id=0898fa3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0898fa3a"]])

export default __exports__